import { BaseService } from "../../base";
export class ScheduleDetailService extends BaseService {
  static get entity() {
    return "schedule_detail";
  }
  static get name() {
    return "schedule_detail";
  }

  static async getByDaySelectedId(day_selected_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_day_selected_id/${day_selected_id}`, this.name);
  }
  static async getByScheduleId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_schedule_id/${id}`, this.name);
  }
  static async getFreeScheduleDetail(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/free_schedule_detail/${id}`, this.name);
  }
  static async getByScheduleDetailByDate(data) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_date_and_schedule/${data.date}/${data.schedule_id}`, this.name);
  }
  static async storeOvercrowd(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/store_overcrowd`, this.name, data);
  }
  static async blockScheduleDetails(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/block_schedule_details`, "schedule_details", data);
  }
  static async findByProfessional(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_professional`, this.name, data);
  }
  static async detail_report(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/detail_schedule_report`, null, payload, {
      responseType: "blob",
    });
  }

  static async exportMentalHealthCitationReport(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/export_mental_health_citation_report`, null, payload, {
      responseType: "blob",
    });
  }
}
